<mat-tab-group>
  <mat-tab>
    <ng-template mat-tab-label>
      <span i18n>Einzelprojekte</span>
    </ng-template>
    <mat-action-list>
      @for (project of recentlyEditedSingleProjects(); track project.id) {
        <button mat-list-item class="project" (click)="loadHistoryProject(project)">
          <div class="project-name" matListItemTitle>{{ project.name }}</div>
          <div class="last-updated" matListItemLine i18n>Bearbeitet {{ project.updatedAt | timeAgo }}</div>
        </button>
      } @empty {
        <div class="no-projects" i18n>Es existieren keine Einzelprojekte in Deinem Account.</div>
      }
    </mat-action-list>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      <mat-icon>groups</mat-icon>
      <span i18n>Teamprojekte</span>
    </ng-template>
    <mat-action-list>
      @for (project of recentlyEditedTeamProjects(); track project.id) {
        <button mat-list-item class="project" (click)="loadHistoryProject(project)">
          <div class="project-name" matListItemTitle>{{ project.name }}</div>
          <div class="last-updated" matListItemLine i18n>Bearbeitet {{ project.updatedAt | timeAgo }}</div>
        </button>
      } @empty {
        <div class="no-projects" i18n>Es existieren keine Teamprojekte in Deinem Account.</div>
      }
    </mat-action-list>
  </mat-tab>
</mat-tab-group>
